import { APIBinderData } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation, validateFailedObjects } from '../utils/helpers';

export const processDateFirstLicensedData = (
  binderReportData: APIBinderData,
  remarks: Remark[] = [],
  validation?: Validation,
): BinderSectionData => {
  const mvrData = binderReportData?.mvr_data || [];
  const drivers = binderReportData.application_data?.drivers || [];
  const companyInfo =
    binderReportData.application_data?.company_and_broker_information;

  const driverRows = drivers.map((driver, index: number) => {
    const appDateFirstLicensed = driver?.licensed_date || '';
    const mvrLicenseIssueDate = mvrData[index]?.license_issue_date || '';
    const isValid = validateFailedObjects(index, validation);

    return {
      driverName: driver?.name || '',
      appDateFirstLicensed: appDateFirstLicensed,
      mvrLicenseIssueDate: mvrLicenseIssueDate,
      mvrExpiryDate: mvrData[index]?.expiry_date || '',
      mvrBirthdate: mvrData[index]?.birthdate || '',
      remarks: remarks.find((r) => r.item_key === `driver-${index + 1}`)?.text,
      isValid,
    };
  });

  const validationData = processValidation(validation);

  return {
    title: 'Date first licensed',
    description: 'Check to ensure that the date first licensed is correct.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      driverRows,
      insuranceCompany: companyInfo?.insurance_company || null,
    },
  };
};
